import { Component } from "react";
import { reportError } from "@/lib/errorReporter";

/** Évite la page blanche quand un écran plante, et remonte l'erreur automatiquement. */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    reportError({ kind: "plantage d'écran", message: error?.message || String(error), stack: error?.stack, componentStack: info?.componentStack });
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#FAFAF8" }}>
        <div className="max-w-sm text-center space-y-3">
          <img src="/veyer-ciel-logo.png" alt="Véyèr CIEL" className="h-14 mx-auto" />
          <h1 className="text-lg font-bold" style={{ color: "#1A1A1A" }}>Cet écran a rencontré un problème</h1>
          <p className="text-sm" style={{ color: "#4A4A4A" }}>
            L'erreur a été signalée automatiquement à l'équipe Véyèr CIEL. Rechargez la page pour continuer :
            vos saisies déjà enregistrées ne sont pas perdues.
          </p>
          <div className="flex gap-2 justify-center">
            <button onClick={() => window.location.reload()} className="h-10 px-4 rounded-xl text-white text-sm font-semibold" style={{ background: "#2D6A4F" }}>
              Recharger la page
            </button>
            <button onClick={() => { window.location.href = "/dashboard"; }} className="h-10 px-4 rounded-xl text-sm font-semibold border border-black/10">
              Tableau de bord
            </button>
          </div>
        </div>
      </div>
    );
  }
}
